import SplashScreen from "@/components/SplashScreen";
import useAuth from "@/hooks/useAuth";
import { FC, ReactNode, useEffect, useRef, useState } from "react";
import { shallow } from "zustand/shallow";
import { getUserByToken } from "@/utils/api";

interface AuthProps {
  children: ReactNode;
}

const Auth: FC<AuthProps> = ({ children }) => {
  const { auth, logout, setUser } = useAuth((state) => state, shallow);
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const response = await getUserByToken();
          if (response && response.payload && response.payload.user) {
            setUser(response.payload.user);
          }
        }
      } catch (error) {
        console.warn(error);
        if (!didRequest.current) {
          logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    if (auth && auth.token) {
      requestUser();
    } else {
      logout();
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <SplashScreen /> : <>{children}</>;
};

export default Auth;
